import { render, staticRenderFns } from "./ResidentStatementsTab.vue?vue&type=template&id=3ff866a0&scoped=true&"
import script from "./ResidentStatementsTab.vue?vue&type=script&lang=ts&"
export * from "./ResidentStatementsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff866a0",
  null
  
)

export default component.exports